import { OrderStatus, Sources } from "../utils/enum";
import { OrderV2 } from "../v2/queries/interfacesV2";
import useBranches from "./useBranches";

const useOrderInformationHook = (order: OrderV2) => {
  const branches = useBranches();
  const { order_information } = order || {};

  const isUber = order_information?.source === Sources.UBER_EATS;
  const isThuisbezorgd = order_information?.source === Sources.THUISBEZORGD_NL;
  const isDeliveroo = order_information?.source === Sources.DELIVEROO;
  const isPos = order_information?.source === Sources.POS;
  const isHomie = order_information?.source === Sources.HOMIE;
  const isWebsite =
    !isUber && !isThuisbezorgd && !isDeliveroo && !isPos && !isHomie;

  const canDeny =
    !isThuisbezorgd && order_information?.order_status === OrderStatus.ARRIVED;
  const isAsap = order_information?.hand_over_is_asap;
  const branchGroup = branches.find(
    (br) => br.branch.id === order_information?.branch_id
  );

  const isExternalOrder = isUber || isThuisbezorgd || isDeliveroo || isHomie;

  return {
    ...(order_information || {}),
    isPos,
    isAsap,
    isUber,
    isThuisbezorgd,
    isWebsite,
    canDeny,
    isHomie,
    branchGroup,
    isExternalOrder,
  };
};

export default useOrderInformationHook;
